import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from '../../components/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCalendarAlt, faTag } from '@fortawesome/free-solid-svg-icons';
import { announcements } from '../../data/announcements';
import '../Announcements.css';

// Import images
import duyurularHeroImage from '../../assets/images/duyurular.jpg';

const AnnouncementsEN = () => {
  // Translate announcement data for English
  const translateAnnouncement = (announcement) => {
    const translations = {
      'etkim-bakan-ziyareti': {
        title: 'Minister of National Education Prof. Dr. Yusuf Tekin\'s ETKİM Visit',
        excerpt: 'With the attendance of our Minister of National Education, Prof. Dr. Yusuf Tekin, the "Educational Technologies Ecosystem Meeting" was held hosted by ETKİM.',
        category: 'Event'
      },
      'bett-uk-ziyaret': {
        title: 'Deputy Minister and Director General Visit at BETT UK',
        excerpt: 'At BETT UK, Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit, and Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı, visited the ProgenX stand.',
        category: 'Event'
      },
      'bett-uk-bakan-yardimcisi-ziyareti': {
        title: 'Deputy Minister and Director General Visit at BETT UK',
        excerpt: 'At BETT UK, Deputy Minister of the Ministry of National Education, Mr. M. Bilal Macit, and Director General of Innovation and Educational Technologies, Mr. Mustafa Canlı, visited the ProgenX stand.',
        category: 'Event'
      },
      'bett-uk-2026': {
        title: 'We are at BETT UK 2026!',
        excerpt: 'As ProgenX Education and Information Technologies Inc., we are representing our country in London at the Ministry of National Education pavilion.',
        category: 'Event'
      },
      'takeoff-istanbul-2025': {
        title: 'We Participated in Take Off İstanbul 2025!',
        excerpt: 'We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! Thank you to all local and international participants who visited our stand and closely examined ProgenX solutions.',
        category: 'Event'
      },
      'take-off-istanbul-2025': {
        title: 'We Participated in Take Off İstanbul 2025!',
        excerpt: 'We completed the 2nd day of Take Off İstanbul 2025 with great interest and valuable encounters! Thank you to all local and international participants who visited our stand and closely examined ProgenX solutions.',
        category: 'Event'
      },
      'tetz2025-sonuc-raporu': {
        title: 'We Were Featured in TETZ 2025 Results Report!',
        excerpt: 'We were featured in the published results report of Turkey Education Technologies Summit 2025 (TETZ 2025)!',
        category: 'Event'
      },
      'teknogirisim-rozeti-2025': {
        title: 'ProgenX Earned the Techno-Entrepreneurship Badge!',
        excerpt: 'As ProgenX, we are proud to be one of the first startups to earn the Techno-Entrepreneurship Badge awarded by the Ministry of Industry and Technology of the Republic of Turkey.',
        category: 'Award'
      },
      'aws-activate-2025': {
        title: 'ProgenX Accepted into AWS Activate Program!',
        excerpt: 'As ProgenX, we have been accepted into the AWS Activate program. With this important development, we have gained the opportunity to develop our AI-based projects more strongly.',
        category: 'Program'
      },
      'tetz-2025': {
        title: 'We Shaped the Future Together at TETZ 2025!',
        excerpt: 'As ProgenX, we are very proud and happy to be part of the Turkey Education Technologies Summit (TETZ 2025) held between June 20-22.',
        category: 'Event'
      },
      'sosyal-sorumluluk-2025': {
        title: 'Supporting Education with Technology: A Social Responsibility Step from ProgenX',
        excerpt: '🌟 ProgenX is touching the future in education!',
        category: 'Social Responsibility'
      },
      'progenx-kurulus': {
        title: 'ProgenX Officially Established!',
        excerpt: 'ProgenX Education and Information Technologies Inc., officially registered in the Turkey Trade Registry Gazette, has set out to offer innovative and sustainable solutions in areas such as education technologies, software development, and AI consulting.',
        category: 'Corporate'
      },
      'tubitak-mukemmeliyet-muhru': {
        title: 'TÜBİTAK Excellence Seal Award',
        excerpt: 'ProgenX was deemed worthy of an important award such as the TÜBİTAK Excellence Seal with the support of the 1812 - Investment-Based Entrepreneurship Support Program (BiGG Investment) as a result of studies conducted under HAVELSAN consultancy.',
        category: 'Award'
      }
    };
    
    const translation = translations[announcement.id];
    if (translation) {
      return {
        ...announcement,
        title: translation.title,
        excerpt: translation.excerpt,
        category: translation.category
      };
    }
    return announcement;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "ProgenX Announcements",
    "description": "ProgenX's latest announcements, news, events, and campaigns",
    "url": "https://progenxacademy.com/en/announcements",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": announcements.map((announcement, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "NewsArticle",
          "headline": translateAnnouncement(announcement).title,
          "datePublished": announcement.date,
          "url": `https://progenxacademy.com/en/announcements/${announcement.slug}`,
          "description": translateAnnouncement(announcement).excerpt
        }
      }))
    }
  };

  return (
    <div className="announcements">
      <Helmet>
        <title>ProgenX Announcements | Latest News and Developments 2025</title>
        <meta name="description" content="ProgenX's latest announcements, news, events, and campaigns. Stay informed about the latest developments in education technologies, artificial intelligence, and software. TETZ 2025, AWS Activate, Techno-Entrepreneurship Badge and more." />
        <meta name="keywords" content="progenx announcements, progenx news, progenx campaigns, progenx events, education technology announcements, tetz 2025, aws activate, techno-entrepreneurship badge, progenx developments" />
        <meta property="og:title" content="ProgenX Announcements | Latest News and Developments" />
        <meta property="og:description" content="ProgenX's latest announcements, news, and events. Stay informed about the latest developments in education technologies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en/announcements" />
        <link rel="canonical" href="https://progenxacademy.com/en/announcements" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com/duyurular" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en/announcements" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <Hero 
        title="ANNOUNCEMENTS" 
        backgroundImage={duyurularHeroImage}
      />
      
      <section className="announcements-content">
        <div className="container">
          <h2 className="section-title">Latest Announcements</h2>
          <p className="announcements-intro">
            You can follow ProgenX's latest developments, events, and achievements in education technologies, 
            artificial intelligence, and software here.
          </p>
          
          <div className="announcements-list">
            {announcements.map(announcement => {
              const translated = translateAnnouncement(announcement);
              return (
                <article 
                  key={announcement.id}
                  className={`announcement-card ${announcement.isHighlighted ? 'highlighted' : ''}`}
                >
                  <div className="announcement-header">
                    <div className="announcement-meta">
                      <span className="announcement-category">
                        <FontAwesomeIcon icon={faTag} /> {translated.category || (() => {
                          const categoryTranslations = {
                            'Etkinlik': 'Event',
                            'Ödül': 'Award',
                            'Program': 'Program',
                            'Sosyal Sorumluluk': 'Social Responsibility',
                            'Kurumsal': 'Corporate'
                          };
                          return categoryTranslations[announcement.category] || announcement.category;
                        })()}
                      </span>
                      <span className="announcement-date">
                        <FontAwesomeIcon icon={faCalendarAlt} /> {announcement.date}
                      </span>
                    </div>
                  </div>
                  
                  <h3 className="announcement-title">{translated.title}</h3>
                  <p className="announcement-excerpt">{translated.excerpt}</p>
                  
                  <Link 
                    to={`/en/announcements/${announcement.slug}`}
                    className="announcement-link"
                  >
                    Read More
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsEN;
